import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, LogOut } from "lucide-react";
import { useState } from "react";
import { useAuth } from "@/lib/AuthContext";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/feed", label: "Feed" },
  { to: "/shop", label: "Shop" },
  { to: "/submit", label: "Submit" },
  { to: "/admin", label: "Admin" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <header className="border-b-ink bg-[#F4F4F0] sticky top-0 z-40" data-testid="site-header">
      <div className="max-w-[1400px] mx-auto px-4 md:px-10 py-4 flex items-center justify-between gap-3">
        <Link to="/" className="flex items-baseline gap-3 min-w-0" data-testid="brand-link">
          <span className="font-display text-[22px] md:text-[30px] font-black leading-none truncate">tobeveryhonest</span>
          <span className="font-ui text-[10px] text-[#FF3333] hidden lg:inline">.COM — REFERENCE FOR CANDOUR</span>
        </Link>
        <nav className="hidden md:flex items-center gap-2" data-testid="nav-desktop">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className={({ isActive }) => `pill ${isActive ? "active" : ""}`}
            >
              {n.label}
            </NavLink>
          ))}
          {user && (
            <button onClick={async () => { await logout(); navigate("/"); }} className="pill" data-testid="nav-logout" title={user.email}>
              <LogOut size={12} />
            </button>
          )}
        </nav>
        <button
          className="md:hidden pill"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="nav-toggle-mobile"
        >
          {open ? <X size={16} /> : <Menu size={16} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t-ink px-4 py-3 flex flex-col gap-2" data-testid="nav-mobile">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-${n.label.toLowerCase()}`}
              className={({ isActive }) => `pill w-fit ${isActive ? "active" : ""}`}
            >
              {n.label}
            </NavLink>
          ))}
          {user && (
            <button onClick={async () => { setOpen(false); await logout(); navigate("/"); }} className="pill w-fit" data-testid="nav-mobile-logout">
              <LogOut size={12} /> Sign out
            </button>
          )}
        </div>
      )}
    </header>
  );
}
